import api from './api';

/**
 * Busca todos os atestados de um paciente
 * @param {number} codPac - Código do paciente
 * @returns {Promise<Array>} Lista de atestados
 */
export const getAtestadosPaciente = async (codPac) => {
  const { data } = await api.get(`paciente/${codPac}/atestados`);
  return data;
};

/**
 * Busca um atestado específico por ID
 * @param {number} codAtestado - Código do atestado
 * @returns {Promise<Object>} Dados do atestado
 */
export const getAtestadoById = async (codAtestado) => {
  const { data } = await api.get(`atestado/${codAtestado}`);
  return data;
};

/**
 * Cria um novo atestado
 * @param {Object} payload - Dados do atestado
 * @param {number} payload.codConsulta - Código da consulta
 * @param {number} payload.codMedico - Código do médico
 * @param {number} payload.codPaciente - Código do paciente
 * @param {number} payload.tipoAtestado - ID do tipo de atestado
 * @param {string} payload.descricao - Texto do atestado
 * @param {string} [payload.cid] - CID (se aplicável)
 * @param {number} [payload.dias] - Número de dias (se aplicável)
 * @param {string} [payload.status='ONLINE'] - Status do atestado
 * @returns {Promise<Object>} Atestado criado
 */
export const createAtestado = async (payload) => {
  const { data } = await api.post('atestado/', payload);

  return data;
};

export const updateAtestado = async (codAtestado, payload) => {
  const { data } = await api.put(`atestado/${codAtestado}`, payload);

  return data;
};

export const deleteAtestado = async (codAtestado) => {
  const { data } = await api.delete(`atestado/${codAtestado}`);
  return data;
};
